export default __webpack_public_path__ + "static/ME-5a000594bd1726877821cc43c8198294.jpg";